<template>
  <!-- 我的订单 -->
  <div class="order-base">
    <div class="order_list-bl" v-if="orderList.length">
      <div class="order-item" v-for="order in orderList" :key="order.id">
        <div class="order-top-wrap">
          <span class="order_num"> 订单号: {{ order.order_num }} </span>
          <span class="order_time"> {{ order.created }} </span>
        </div>
        <div class="order_detail_info-wrap">
          <div class="order-left-wrap">
            <!-- 现场 -->
            <template v-if="order.order_type === 1">
              <div class="line order_title">
                {{ order.order_type | formatOrderType }}
                <span v-if="order.periods">第 {{ order.periods }} 期</span>
              </div>
              <div class="line" v-if="order.screeningList && order.screeningList.length">
                <div class="screening-item" v-for="screening in order.screeningList" :key="screening">
                  {{ screening }}
                </div>
              </div>
              <div class="line" v-if="order.address">地点：{{ order.address }}</div>
              <div class="line">票价：{{ order.price }} 元</div>
            </template>
            <!-- 现场END -->
            <!-- 暂时先这样 分块儿写 后期看能否直接优化掉 -->
            <!-- 会员订单 -->
            <template v-else-if="order.order_type === 2">
              <div class="line order_title">
                {{ order.order_type | formatOrderType }}
              </div>
              <template v-if="order.change_code">
                <div class="mini-title">兑换码：</div>
                <div class="line">
                  {{ order.change_code }}
                </div>
                <div class="line">
                  {{ +order.is_change ? `已兑换：${order.change_mobile}` : '暂未兑换' }}
                </div>
              </template>
              <div class="line" v-if="order.end_time">有效期至：{{ order.end_time }}</div>
              <template v-if="order.address">
                <div class="line">
                  物流信息：{{ order.delivery ? order.delivery : '等待发货' }}<span v-if="order.express_num">，运单号{{ order.express_num }}</span>
                </div>
              </template>
              <div class="line"></div>
              <div class="line">金额：{{ order.price }} 元</div>
            </template>
            <!-- 会员订单END -->
            <!-- 万象单课 -->
            <template v-else-if="order.order_type === 3">
              <div class="line order_title">
                {{ order.wanxiang_name }}
              </div>
              <template v-if="order.change_code">
                <div class="mini-title">兑换码：</div>
                <div class="line">
                  {{ order.change_code }}
                </div>
                <div class="line">
                  {{ +order.is_change ? `已兑换：${order.change_mobile}` : '暂未兑换' }}
                </div>
                <div class="line"></div>
              </template>
              <div class="line">实付价格：{{ order.price }} 元</div>
            </template>
            <!-- 万象单课END -->
            <!-- 万象实物 -->
            <template v-else-if="order.order_type === 4">
              <div class="line order_title">
                {{ order.wanxiang_name }}
              </div>
              <template v-if="order.change_code">
                <div class="mini-title">兑换码：</div>
                <div class="line">
                  {{ order.change_code }}
                </div>
                <div class="line">
                  {{ +order.is_change ? `已兑换：${order.change_mobile}` : '暂未兑换' }}
                </div>
                <div class="line"></div>
              </template>
              <template v-if="!order.change_code">
                <div class="mini-title">收货人信息</div>
                <div class="line">收货人：{{ order.name }} {{ order.mobile }}</div>
                <div class="line">收货地址：{{ order.address }}</div>
                <div class="line"></div>
                <div class="line">价格：{{ order.price }} 元</div>
              </template>
            </template>
            <!-- 万象实物END -->
          </div>
          <div class="order-right-wrap" v-if="order.cover">
            <div class="order_cover ratio16-9">
              <img :src="order.cover" />
            </div>
          </div>
        </div>
        <div class="order-bottom-wrap">
          <div class="order_tips" v-if="order.order_type === 1">
            入场二维码请在一席 App/H5/小程序 中查看
          </div>
          <div class="order_tips" v-else>
            您同时可以在一席 App/H5/小程序 中查看所有会员内容
          </div>
        </div>
      </div>
      <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
    </div>
    <div class="empty-bl" v-else>
      暂无数据
    </div>
  </div>
  <!-- 我的订单END -->
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      orderList: [], // 订单列表
      total: 0,
      pageNum: 1,
      pageSize: 5,
    };
  },
  computed: {
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  filters: {
    formatOrderType(type) {
      let label = '';
      switch (type) {
        case 1: // 现场
          label = '一席现场';
          break;
        case 2: // 会员
          label = '一席会员';
          break;
        case 3: // 万象单课
        case 4:
          label = '一席万象';
          break;
        default:
          break;
      }
      return label;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    /**
     * @description: 获取订单列表
     */
    getData() {
      requestApi('/api/site/order/', {
        page: this.pageNum,
        page_size: this.pageSize,
      }).then(({ items, total }) => {
        if (this.pageNum === 1) {
          this.orderList = this.handleData(items);
          this.total = total;
        } else {
          this.orderList.push(...this.handleData(items));
        }
      });
    },
    /**
     * @description: 处理订单列表数据
     */
    handleData(data) {
      data.forEach(item => {
        if (item.order_type === 1) {
          item.screeningList = this.handleScreening(item.screening);
        }
      });
      return data;
    },
    /**
     * @description: 处理场次逻辑
     */
    handleScreening(data) {
      const map = {};
      for (const item of data) {
        const arr = item.begin_date.split(' ');
        if (!map[arr[0]]) map[arr[0]] = [];
        map[arr[0]].push(`${item.name} ${arr[1]} - ${item.end_date.split(' ')[1]}`);
      }
      const res = [];
      Object.keys(map).forEach(date => {
        const arr = map[date];
        const str = arr.join(' ');
        res.push(`时间：${date} ${str}`);
      });
      return res;
    },
    /**
     * @description: 订单加载更多
     */
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.order-base {
  min-height: 100%;
  height: 100%;
}
.order_list-bl {
  .order-item {
    background: $C1;
    margin-bottom: 10px;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
    padding: 0 30px;
    border-radius: 3px;
    transition: box-shadow 0.3s ease-in;
    &:hover {
      box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
    }
    .order-top-wrap {
      border-bottom: 1px solid $C10;
      font-size: 14px;
      color: $C6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      .order_num {
      }
      .order_time {
        font-size: 14px;
        font-weight: 300;
      }
    }
    .order_detail_info-wrap {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      padding: 20px 0;
    }
    .order-left-wrap {
      line-height: 30px;
      color: $C6;
      font-size: 14px;
      flex: 1;
      .mini-title {
        font-size: 10px;
        color: $C13;
        line-height: 14px;
        margin-bottom: 5px;
      }
      .line {
        font-size: 12px;
        letter-spacing: 1px;
        line-height: 18px;
        min-height: 14px;
      }
      .order_title {
        font-family: HYXinRenWenSongW;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .order_price {
        color: $C2;
      }
    }
    .order-right-wrap {
      .order_cover {
        width: 236px;
        & > img {
          position: absolute;
          left: 0;
          top: 0;
          max-height: 100%;
        }
      }
    }
    .order-bottom-wrap {
      border-top: 1px dashed $C10;
      text-align: right;
      color: $C12;
      font-size: 14px;
      font-weight: 300;
      margin: 0;
      padding: 18px 0;
    }
  }
}
.empty-bl {
  width: 100%;
  height: 100%;
  background: $C1;
  text-align: center;
  padding-top: 15%;
  box-sizing: border-box;
  color: $C5;
  letter-spacing: 2px;
  font-weight: 300;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
}
</style>
